import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './SuspendedAccountModal.css';

interface SuspendedAccountModalProps {
  show: boolean;
  onHide: () => void;
}

const SuspendedAccountModal: React.FC<SuspendedAccountModalProps> = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      style={{ zIndex: 10050 }}
    >
      <Modal.Header closeButton style={{ borderBottom: '1px solid #fee2e2', backgroundColor: '#fef2f2', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
        <Modal.Title style={{ color: '#dc2626', fontSize: '1.2rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '1.4rem' }}>⚠️</span> Account Suspended
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '24px', textAlign: 'center' }}>
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          backgroundColor: '#fee2e2',
          color: '#dc2626',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px auto',
          fontSize: '2rem'
        }}>
          🚫
        </div>
        <h5 style={{ fontWeight: 600, color: '#1e293b', marginBottom: '10px' }}>
          Your Account Has Been Suspended
        </h5>
        <p style={{ color: '#64748b', fontSize: '0.95rem', lineHeight: 1.5, marginBottom: '16px' }}>
          Your company account has been suspended by the system administrator. 
          You can view and navigate through sidebar pages, but all action capabilities and profile modifications are restricted.
        </p>
        <div style={{ padding: '12px 16px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0', color: '#475569', fontSize: '0.875rem' }}>
          Please contact our support team to resolve suspension or restore full account permissions.
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: 'none', justifyContent: 'center', paddingBottom: '20px' }}>
        <Button
          variant="danger"
          onClick={onHide}
          style={{ padding: '8px 28px', borderRadius: '8px', fontWeight: 500 }}
        >
          Understood
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuspendedAccountModal;
